import { render } from "./TopBarProducts.vue?vue&type=template&id=f550a7c6"
import script from "./TopBarProducts.vue?vue&type=script&lang=js"
export * from "./TopBarProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__